import {
  defaultBlurValidityForm,
  defaultBlurValidityStatusForm,
  defaultValidityForm,
  defaultValidityStatusForm,
} from './utils';

export const initialValidityState = (): ValiditiesState => ({
  filters: {
    products: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
      },
    },
    validities: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
      },
    },
    branches: {
      data: [],
    },
    status: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
      },
    },
    validityStatus: {
      data: [],
    },
  },
  autocompletes: {
    validity: {
      product: {
        data: [],
      },
      section: {
        data: [],
      },
      unit: {
        data: [],
      },
      statusName: {
        data: [],
      },
      branch: {
        data: [],
      },
      code: {
        data: [],
      },
      barcode: {
        data: [],
      },
    },
    status: {
      name: {
        data: [],
      },
      color: {
        data: [],
      },
    },
  },
  forms: {
    validity: {
      create: defaultValidityForm(),
      update: {
        id: '',
        ...defaultValidityForm(),
      },
    },

    status: {
      create: defaultValidityStatusForm(),
      update: {
        id: '',
        ...defaultValidityStatusForm(),
      },
    },
  },
  blur: {
    validity: {
      create: defaultBlurValidityForm(),
      update: defaultBlurValidityForm(),
    },
    status: {
      create: defaultBlurValidityStatusForm(),
      update: defaultBlurValidityStatusForm(),
    },
  },
  selecteds: {
    validities: [],
    status: [],
  },
  selected: {
    validity: null,
    status: null,
  },
  loadings: {
    deleteValidities: [],
    deleteStatus: [],
  },
});
